import { ReactNode, useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  Modal,
  Popconfirm,
  Table,
  TableColumnsType,
} from 'antd';

import { useAppSelector } from '@/core/redux/hooks';
import { systemSelectors } from '@/core/redux/slices/smokeExtraction/system/selectors';

interface IModalData {
  open: boolean;
  header: string;
  type: string;
  saveData: (value: string[]) => void;
  rooms: string[];
}

interface IModal {
  open: boolean;
  setOpen: (value: IModalData | null) => void;
  type: string;
  roomId: string | undefined;
  saveData: any;
  currentRooms: string[];
}

export const LinksModal: React.FC<IModal> = ({
  open,
  setOpen,
  type,
  roomId,
  saveData,
  currentRooms,
}) => {
  const [formRooms, setFormRooms] = useState<string[]>([]);
  const system = useAppSelector(systemSelectors.system);

  useEffect(() => {
    setFormRooms(currentRooms);
  }, [currentRooms]);

  const availableRooms = system?.state?.table?.filter((el: any) => {
    if (
      (el?.type_balance === 'Только приток' &&
        el?.type_inflow === 'По ссылке на вытяжку') ||
      (el?.type_balance === 'Только вытяжка' &&
        el?.type_exhaust === 'По ссылке на приток')
    )
      return;
    if (
      (type === 'exhaust_linked' &&
        el?.flow_exhaust &&
        el?.flow_exhaust - el?.flow_inflow > 0) ||
      (type === 'inflow_linked' &&
        el?.flow_inflow &&
        el?.flow_inflow - el?.flow_exhaust > 0)
    ) {
      if (
        el?.area &&
        el?.volume &&
        el?.height &&
        el?.id !== roomId &&
        el?.[type] === roomId
      )
        return el;

      if (
        el?.area &&
        el?.volume &&
        el?.height &&
        el?.id !== roomId &&
        !el?.[type]
      )
        return el;
    }
  });

  const closeModal = () => {
    setOpen(null);
  };

  const submit = () => {
    saveData(formRooms);
    setOpen(null);
  };

  const handleCheckBox = (id: string) => {
    if (formRooms?.includes(id)) {
      setFormRooms((prev: string[]) => prev?.filter((el: string) => el !== id));
    } else {
      setFormRooms((prev: string[]) => [...prev, id]);
    }
  };

  const columns: TableColumnsType<any> = [
    {
      title: 'Корпус',
      dataIndex: 'block',
      align: 'center',
    },

    {
      title: 'Этаж',
      dataIndex: 'floor',
      align: 'center',
    },
    {
      title: '№',
      dataIndex: 'num',
      align: 'center',
    },
    {
      title: 'Наименование помещения',
      dataIndex: 'name',
      align: 'start',
      width: 300,
    },
  ];

  if (type === 'exhaust_linked') {
    columns.push({
      title: 'Вытяжка',
      dataIndex: 'flow_exhaust',
      render: (text, record, index) => (
        <div>{record?.flow_exhaust - record?.flow_inflow}</div>
      ),
    });
  }

  if (type === 'inflow_linked') {
    columns.push({
      title: 'Приток',
      dataIndex: 'flow_inflow',
      render: (text, record, index) => (
        <div>{record?.flow_inflow - record?.flow_exhaust}</div>
      ),
    });
  }

  columns.push({
    title: '',
    dataIndex: '',
    render: (text, record, index) => (
      <Checkbox
        checked={formRooms?.includes(record?.id)}
        onChange={() => handleCheckBox(record?.id)}
      />
    ),
  });

  const wrapperButton = (children: ReactNode) => {
    return (
      <Popconfirm
        title='Вы уверены, что хотите закрыть окно?'
        description='Внесенные изменения в этом окне не будут сохранены.'
        okText='Закрыть окно'
        cancelText='Отменить'
        placement='bottom'
        onConfirm={closeModal}
      >
        {children}
      </Popconfirm>
    );
  };

  return (
    <Modal
      title={
        <div className='flex items-center justify-between'>
          <div>
            {type === 'similar_rooms' ? 'Однотипные помещения' : 'Ссылка'}
          </div>
          {wrapperButton(
            <Button type='link' className='text-blue p-0 underline'>
              Вернуться к редактированию
            </Button>
          )}
        </div>
      }
      open={open}
      onCancel={closeModal}
      closable={false}
      centered
      footer={null}
      className='min-w-fit'
    >
      <div>
        <Table
          rowKey={'id'}
          columns={columns}
          dataSource={availableRooms}
          pagination={false}
          className='mt-4'
          rowClassName={'text-center'}
        />
        <Button className='mt-2' onClick={() => setFormRooms([])}>
          Отменить все
        </Button>

        <div className='flex gap-2 mt-5 w-full'>
          {wrapperButton(<Button className='w-1/2'>Назад</Button>)}

          <Button className='w-1/2' type='primary' onClick={submit}>
            Сохранить
          </Button>
        </div>
      </div>
    </Modal>
  );
};
